<ng-container [formGroup]="form.formGroup">
    <mat-form-field>
        <mat-label>Customer</mat-label>
        <mat-select [formControlName]="form.formControlNames.customer">
          @for (customer of (customers$ | async); track customer) {
            <mat-option [value]="customer.value">{{customer.name}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
</ng-container>